import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PalletViewRegisterApiService } from '../../../views/pallets/register-pallet/api/view.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TankPalletViewRegisterApiService extends PalletViewRegisterApiService {
  finishPallet(palletId: number): Observable<void> {
    return this.apiPalletRouter
      .finishPallet(palletId)
      .pipe(switchMap(() => this.apiPalletRouter.createPalletReport(palletId)));
  }
}
